import { Pagination, Table, Text } from '@mantine/core';
import { ChangeEvent } from 'react';
import { OpenComponent } from '../../../enums/misc.enum';
import { Roles } from '../../../enums/roles-enum';
import useAuth from '../../../hooks/useAuth';
import { IPaginationMeta } from '../../../type/admin.types';
import { BasicAccount } from '../../../type/retrieve-account.types';
import StatusText from '../../admin-table/components/status-text.component';

const SafeTableData = ({ data }: { data: string }) => {
  return data ? (
    <>{data}</>
  ) : (
    <Text size="sm" color="dimmed" data-cy="businessWebsiteUrl">
      N/A
    </Text>
  );
};

interface Props {
  userData: BasicAccount[] | undefined;
  paginationData: IPaginationMeta | undefined;
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  isChecked: number[];
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  checkedAll: boolean;
  createRequest: (
    page: number,
    clearIsChecked: boolean,
    username?: string
  ) => Promise<void>;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  setClickedUserId: React.Dispatch<React.SetStateAction<number | undefined>>;
  firstUserId: number | undefined;
}

function UserManagementTable(props: Props) {
  const {
    userData,
    setIsChecked,
    isChecked,
    setCheckedAll,
    checkedAll,
    paginationData,
    createRequest,
    setComponentManager,
    setClickedUserId,
    firstUserId
  } = props;

  const { auth } = useAuth();

  const navigateUser = (id: number) => {
    setClickedUserId(id);
    setComponentManager(OpenComponent.VIEW_USER);
  };

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    let arr = userData;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      if (arr) {
        setIsChecked(arr.map((li) => li.accountId));
      }
    }
  };

  return (
    <>
      <div className="admin-table">
        <Table
          highlightOnHover
          sx={{ '& thead tr th': { height: 50 }, whiteSpace: 'nowrap' }}
          horizontalSpacing="md"
        >
          <thead style={{ backgroundColor: '#f6f8fb', color: '#223354' }}>
            <tr style={{ fontSize: '11px' }}>
              {auth?.role !== Roles.SETTLEMENT &&
                auth?.role !== Roles.CHECKER && (
                  <th style={{ width: 30 }}>
                    <input
                      type="checkbox"
                      style={{ cursor: 'pointer' }}
                      onChange={handleCheckAll}
                      checked={checkedAll}
                      data-cy="selectAllMerchants"
                    />
                  </th>
                )}
              <th>Full name</th>
              <th>City</th>
              <th>State</th>
              <th>Country</th>
              <th>Contact number</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {userData ? (
              userData.map((user, index) => {
                const isFirstUser = user.accountId === firstUserId;
                return (
                  <tr
                    key={user.accountId}
                    style={{ backgroundColor: isFirstUser ? '#FFCC00' : '' }}
                  >
                    {auth?.role !== Roles.SETTLEMENT &&
                      auth?.role !== Roles.CHECKER && (
                        <td>
                          <input
                            type="checkbox"
                            style={{ cursor: 'pointer' }}
                            id={user.accountId.toString()}
                            checked={isChecked.includes(user.accountId)}
                            onChange={handleCheck}
                          />
                        </td>
                      )}
                    <td onClick={() => navigateUser(user.accountId)}>
                      <SafeTableData
                        data={
                          (user.user.firstName || '') +
                          ' ' +
                          `${
                            user.user.middleName &&
                            user.user.middleName !== 'N/A' &&
                            user.user.middleName !== '.'
                              ? user.user.middleName
                              : ''
                          }` +
                          ' ' +
                          (user.user.lastName || '')
                        }
                      />
                    </td>
                    <td onClick={() => navigateUser(user.accountId)}>
                      {user.user.address.city}
                    </td>
                    <td onClick={() => navigateUser(user.accountId)}>
                      <SafeTableData data={user.user.address.state} />
                    </td>
                    <td onClick={() => navigateUser(user.accountId)}>
                      <SafeTableData
                        data={
                          user.user.address?.countryId === 1
                            ? 'Philippines'
                            : ''
                        }
                        //TODO make countryID into country text
                      />
                    </td>
                    <td onClick={() => navigateUser(user.accountId)}>
                      <SafeTableData data={user.contact.phone.primary} />
                    </td>
                    <td onClick={() => navigateUser(user.accountId)}>
                      <StatusText
                        status={user.isActive ? 'ENABLED' : 'DISABLED'}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        {userData && userData.length > 0 && (
          <Pagination
            total={paginationData?.totalPages || 1}
            onChange={(value: number) => createRequest(value, true)}
            page={paginationData?.currentPage}
            position="center"
            p="md"
            spacing="md"
          />
        )}
      </div>
    </>
  );
}

export default UserManagementTable;
